var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-radios" }, [
    _c(
      "fieldset",
      { staticClass: "form-radios__fieldset" },
      [
        _vm.legend
          ? _c("legend", { staticClass: "form-radios__fieldset-legend" }, [
              _c("span", {
                staticClass: "form-radios__fieldset-legend-text",
                domProps: { innerHTML: _vm._s(_vm.legend) },
              }),
              _vm._v(" "),
              _vm.legendOption
                ? _c("span", {
                    staticClass: "form-radios__fieldset-legend-option",
                    domProps: { innerHTML: _vm._s(_vm.legendOption) },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.options, function (option, index) {
          return _c(
            "div",
            {
              key: option.value,
              staticClass: "form-radio",
              class: {
                "form-radio--block": _vm.vertical,
                "form-radio--error": _vm.error,
              },
            },
            [
              _c("input", {
                staticClass: "form-radio__field",
                attrs: {
                  type: "radio",
                  id: _vm.uniqueId + "-" + index + "-" + option.value,
                  name: _vm.name,
                  required: _vm.required,
                  disabled: _vm.disabled,
                },
                domProps: {
                  value: option.value,
                  checked: option.value === _vm.value,
                },
                on: { change: _vm.onChange },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-radio__label",
                  attrs: {
                    for: _vm.uniqueId + "-" + index + "-" + option.value,
                  },
                },
                [
                  _c("span", { staticClass: "form-radio__label-box" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "form-radio__label-text" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(option.label) + "\n\t\t\t\t\t"
                      ),
                      _vm._t("default"),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _vm.hint
          ? _c("span", {
              staticClass: "form-radio__hint | form-input-hint",
              domProps: { innerHTML: _vm._s(_vm.hint) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.error && _vm.errorMessage
          ? _c("span", {
              staticClass: "form-radio__error | form-input-error",
              domProps: { innerHTML: _vm._s(_vm.errorMessage) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.successMessage
          ? _c("span", {
              staticClass: "form-radio__success | form-input-success",
              domProps: { innerHTML: _vm._s(_vm.successMessage) },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }